import React, { FunctionComponent } from "react"

interface CrownIconProps {
  color?: string
}

const CrownIcon: FunctionComponent<CrownIconProps> = ({ color="#2F373D" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33325 13.3337H12.6666M1.33325 2.66699L3.33325 10.667H12.6666L14.6666 2.66699L10.6666 7.33366L7.99992 2.66699L5.33325 7.33366L1.33325 2.66699Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default CrownIcon
